import { render, staticRenderFns } from "./CompanyChargesRegistry.vue?vue&type=template&id=4bbb97c0&scoped=true&"
import script from "./CompanyChargesRegistry.vue?vue&type=script&lang=js&"
export * from "./CompanyChargesRegistry.vue?vue&type=script&lang=js&"
import style0 from "./CompanyChargesRegistry.vue?vue&type=style&index=0&id=4bbb97c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbb97c0",
  null
  
)

export default component.exports